/** 한 자리 수(1–9)면 앞에 0을 붙임 */
export const padCareerDatePart = (value: string): string => {
  if (/^[1-9]$/.test(value)) return `0${value}`;
  return value;
};

/** 연·월·일을 `.`으로 이어 표시 (빈 값은 생략) */
export const formatCareerDateParts = (
  year: string,
  month: string,
  day: string,
): string => {
  if (!year) return '';
  return [year, month, day].filter(Boolean).join('.');
};

/** 경력 시작일 — 편집 모드·확장 모드에 따라 표시 값 결정 */
export const getCareerStartDateDisplay = (
  startYear: string,
  startMonth: string,
  startDay: string,
  { isEditMode, isExtended }: { isEditMode: boolean; isExtended: boolean },
): string => {
  if (isEditMode || !isExtended) return startYear;
  return formatCareerDateParts(startYear, startMonth, startDay);
};

/** 경력 종료일 — 편집 모드·확장 모드에 따라 표시 값 결정 */
export const getCareerEndDateDisplay = (
  endYear: string,
  endMonth: string,
  endDay: string,
  { isEditMode, isExtended }: { isEditMode: boolean; isExtended: boolean },
): string => {
  if (isEditMode || !isExtended) return endYear;

  const formatted = formatCareerDateParts(endYear, endMonth, endDay);
  if (!formatted) return '';
  return `~${formatted}`;
};
